import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/index';
import { SatelliteSurveillanceState } from './satellite-surveillance.state';

const satelliteSurveillanceSelector = (satelliteSurveillances: SatelliteSurveillanceState) => satelliteSurveillances.satelliteSurveillance;

const satelliteNowSelector = (satelliteSurveillances: SatelliteSurveillanceState) => satelliteSurveillances.satelliteNow;

const loadingSelector = (satelliteSurveillances: any) => satelliteSurveillances.satelliteSurveillance.loading;

@Injectable()
export class SatelliteSurveillanceSelectors {
    constructor(private store: Store<any>) {
    }

    selectSatelliteSurveillances(): Observable<any> {
        return this.store
            .pipe(select(satelliteSurveillanceSelector));
    }

    selectSatelliteNow(): Observable<any> {
        return this.store
            .pipe(select(satelliteNowSelector));
    }

    selectLoadingStatus(): Observable<boolean> {
        return this.store.pipe(select(loadingSelector));
    }
}
